import { Injectable } from '@angular/core';
import { TemplateFormSchema } from '@models';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { IntakeFormTemplateService } from './intake-form-template.service';

@Injectable({
  providedIn: 'root',
})
export class IntakeFormTemplateApiService
  extends HttpService<TemplateFormSchema>
  implements IntakeFormTemplateService
{
  protected override readonly collectionPath = '/consultation-form';

  getTemplate(): Observable<TemplateFormSchema> {
    return this.http.get<TemplateFormSchema>(`${this.apiUrl}/template`);
  }
}
